import { ReactElement, useContext, useEffect, useState } from "react";

import { title, description } from "global-components/mfa/constants/mfaCopy";

import { Factor, FactorData, FactorKey } from "types/factor/factor";

import RemoveFactorContext from "global-components/mfa/contexts/RemoveFactorContext";

import useGetAllFactors from "hooks/useGetAllFactors";
import useGetFeatureFlags from "hooks/useGetFeatureFlags";

import PageLoading from "global-components/pageLoading/PageLoading";
import PageCard from "global-components/pageCard/PageCard";
import FactorList from "global-components/mfa/components/factorList/FactorList";

import buildFactorLists from "global-components/mfa/util/buildFactorLists";

const filterPasskeyFactor = (factorData: FactorData): FactorData => ({
  ...factorData,
  factorOrder: factorData.factorOrder.filter(
    (key) => key !== FactorKey.WebAuthn,
  ),
});

const MfaContainer = (): ReactElement => {
  const { data: factorData } = useGetAllFactors();
  const { data: featureFlags } = useGetFeatureFlags();
  const [factorLists, setFactorLists] = useState<Factor[][]>([[], []]);
  const [activeFactors, inactiveFactors] = factorLists;

  const { setFactorData } = useContext(RemoveFactorContext);

  const isPasskeyEnabled =
    featureFlags?.["ciam-pim_okta_passkey_enrollment_enabled"] ?? false;

  useEffect(() => {
    if (!factorData) return;

    const data = isPasskeyEnabled
      ? factorData
      : filterPasskeyFactor(factorData);

    setFactorLists(buildFactorLists(data));
  }, [factorData, isPasskeyEnabled]);

  useEffect(() => setFactorData(factorData), [setFactorData, factorData]);

  if (!factorData) return <PageLoading />;

  return (
    <PageCard showBackToHomeLink={true} title={title} description={description}>
      <FactorList title="Active Factors" factors={activeFactors} />
      <FactorList title="Available Factors" factors={inactiveFactors} />
    </PageCard>
  );
};

export default MfaContainer;
